<div style="text-align: center">
  <ion-spinner name="lines-small" diameter="40" style="color: green; margin-top: 4vh"> </ion-spinner>
</div>
